/**
 * copy_link_controller.js — copy a readonly input to the clipboard (Stimulus).
 *
 * Element-scoped controller (data-controller="copy-link") wrapping a source input
 * and a trigger button. The button carries data-action="copy-link#copy"; on click
 * it copies the source input's value to the clipboard and flips the button to a
 * transient "Copied!" success state for 2s before restoring its original markup.
 *
 * Targets: source (the input to copy), button (the trigger). Used by the waitlist
 * thanks page's referral-link box. Replaces an inline <script> that defined a
 * window.copyReferralLink global and bound via data-action="call-fn" — but the lean
 * public shell does not load global-actions.js, so call-fn delegation is unavailable
 * there. Stimulus re-connects after each Turbo <body> swap; the revert timer is
 * cleared in disconnect() so it never fires against a detached button.
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
        static targets = ['source', 'button'];

        connect() {
            this._originalHtml = this.buttonTarget.innerHTML;
        }

        disconnect() {
            if (this._timer) clearTimeout(this._timer);
        }

        copy() {
            var input = this.sourceTarget;
            input.select();
            input.setSelectionRange(0, 99999);
            navigator.clipboard.writeText(input.value);

            var button = this.buttonTarget;
            if (this._timer) clearTimeout(this._timer);
            button.innerHTML = '<i class="bi bi-check me-2"></i>Copied!';
            button.classList.remove('btn-primary');
            button.classList.add('btn-success');

            var self = this;
            this._timer = setTimeout(function () {
                button.innerHTML = self._originalHtml;
                button.classList.remove('btn-success');
                button.classList.add('btn-primary');
            }, 2000);
        }
}
